export default "__VITE_PUBLIC_ASSET__df28ea66__"